import React from "react";
import { Route, Switch } from "react-router-dom";


import Home from "./containers/Home";
import AllAltioms from "./containers/AllAltioms";
import Altiom from "./containers/Altiom";
import Branch from "./containers/Branch";
import BranchTemperature from "./containers/BranchTemperature";
import AltiomList from "./containers/AltiomList";
import Forms from "./containers/Forms"
import Admin from "./containers/Admin"
import AdminUsers from "./containers/AdminUsers"
import AdminBranch from "./containers/AdminBranch"
import AdminCodes from "./containers/AdminCodes"
import AdminCodesRef from "./containers/AdminCodeRef"
import AdminBranchRef from "./containers/AdminBranchRef"

import AdminUserRef from "./containers/AdminUserRef"

import AuthCodes from "./containers/AuthCode"
import SMSresp from "./containers/SMSresp"
import DoorControl from "./containers/Door/DoorControl.js"


import AppliedRoute from "./components/AppliedRoute";
import UnauthenticatedRoute from "./components/UnauthenticatedRoute";
import AuthenticatedRoute from "./components/AuthenticatedRoute";

import Signup from "./containers/Signup";
import Login from "./containers/Login";
import Settings from "./containers/Settings";
import ResetPassword from "./containers/ResetPassword";
import ChangeEmail from "./containers/ChangeEmail";
import ChangePassword from "./containers/ChangePassword";

import NotFound from "./containers/NotFound";
import ProgramHome from "./programmerContainers/ProgramHome";
import DownloadFile from "./containers/DownloadFile"
export default ({ childProps }) =>
  <Switch>
    <AppliedRoute path="/" exact component={Home} props={childProps} />
    <AuthenticatedRoute path="/AllAltioms" exact component={AllAltioms} props={childProps} />
    <UnauthenticatedRoute path="/signup" exact component={Signup} props={childProps} />
    <UnauthenticatedRoute path="/login" exact component={Login} props={childProps} />
    <UnauthenticatedRoute path="/login/reset"  exact  component={ResetPassword}  props={childProps}/>
    <AuthenticatedRoute path="/auth/:id"  exact  component={AuthCodes}  props={childProps}/>
    <AuthenticatedRoute path="/download/:id/:file"  exact  component={DownloadFile}  props={childProps}/>
    <AuthenticatedRoute path="/settings"  exact  component={Settings}  props={childProps}/>
    <AuthenticatedRoute path="/settings/email" exact component={ChangeEmail}  props={childProps} />
    <AuthenticatedRoute path="/settings/password"  exact component={ChangePassword} props={childProps} />

    <AuthenticatedRoute path="/sms/:id"  exact component={SMSresp} props={childProps} />
    <AuthenticatedRoute path="/door/:id"  exact component={DoorControl} props={childProps} />
    <AuthenticatedRoute path="/Forms/:formid/:user"  exact component={Forms} props={childProps} />
    <AuthenticatedRoute path="/a/"  exact  component={AltiomList}  props={childProps}/>
    <AuthenticatedRoute path="/a/:id"  exact  component={Altiom}  props={childProps}/>
    <AuthenticatedRoute path="/b/:id"  exact  component={Branch}  props={childProps}/>
    <AuthenticatedRoute path="/b/:id/temperature"  exact  component={BranchTemperature}  props={childProps}/>
    <AuthenticatedRoute path="/program/:id"  exact  component={ProgramHome}  props={childProps}/>
    <AuthenticatedRoute path="/admin/"  exact  component={Admin}  props={childProps}/>
    <AuthenticatedRoute path="/admin/users"  exact  component={AdminUsers}  props={childProps}/>
    <AuthenticatedRoute path="/admin/branch"  exact  component={AdminBranch}  props={childProps}/>
    <AuthenticatedRoute path="/admin/codes"  exact  component={AdminCodes}  props={childProps}/>
    <AuthenticatedRoute path="/admin/code/:id"  exact  component={AdminCodesRef}  props={childProps}/>
    <AuthenticatedRoute path="/admin/branch/:id"  exact  component={AdminBranchRef}  props={childProps}/>
    <AuthenticatedRoute path="/admin/users/:id"  exact  component={AdminUserRef}  props={childProps}/>

    { /* Finally, catch all unmatched routes */ }
    <Route component={NotFound} />
  </Switch>;



// WEBPACK FOOTER //
// ./src/Routes.js